package com.eladfinish.bible.contest.ui.common

import androidx.compose.foundation.border
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.colorPrimaryDark
import com.eladfinish.bible.contest.common.gender.HebrewGender
import com.eladfinish.bible.contest.common.gender.personalizeGender
import com.eladfinish.bible.contest.strokeColor
import com.eladfinish.bible.contest.ui.extensions.conditional
import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.compose.colorResource
import dev.icerock.moko.resources.compose.stringResource

@Composable
fun AppActionButton(
    modifier: Modifier = Modifier,
    stringResource: StringResource,
    onClick: () -> Unit,
    onLongClick: () -> Unit,
    hebrewGender: HebrewGender,
    fontSize: TextUnit = 18.sp,
    isDebug: Boolean = false,
) {
    Button(
        elevation = ButtonDefaults.buttonElevation(
            defaultElevation = 0.dp,
            pressedElevation = 8.dp,
            disabledElevation = 0.dp
        ),
        onClick = onClick,
        modifier = modifier
            .fillMaxWidth()
            .border(
                width = 1.dp,
                color = colorResource(resource = SharedRes.colors.strokeColor),
                shape = RoundedCornerShape(12.dp),
            ),
        shape = RoundedCornerShape(12.dp),
        colors = ButtonDefaults.buttonColors(
            containerColor = colorResource(resource = SharedRes.colors.colorPrimaryDark),
        ),
        contentPadding = PaddingValues(1.dp),
    ) {
        Box(
            modifier = Modifier,
            contentAlignment = Alignment.TopEnd,
        ) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center,
                modifier = Modifier
                    .heightIn(min = 50.dp)
                    .fillMaxWidth()
                    .conditional(condition = isDebug) {
                        combinedClickable(
                            onClick = onClick,
                            onLongClick = onLongClick,
                        )
                    },
            ) {

                Text(
                    text = stringResource(resource = stringResource).personalizeGender(hebrewGender),
                    fontSize = fontSize,
                    style = MaterialTheme.typography.labelLarge,
                    textAlign = TextAlign.Center,
                    color = Color.White,
                )
            }
        }
    }
}
